export class BsModalConfig {
  backdrop = true;
  ignoreBackdropClick = true;
}
